import React from "react";
import { graphql } from "gatsby";
import { MDXRenderer } from "gatsby-plugin-mdx";
import Layout from "../components/layout/Layout";
import SEO from "../components/SEO";
import Article from "./../components/layout/Article";

const PrivacyPage = ({ data }) => (
  <Layout sidebar={{ recentPosts: true, search: true }}>
    <SEO title="Privacy Policy" />
    <Article title="Privacy Policy">
      <p className="text-sm text-neutral-dark mb-2">
        Updated: {data.file.childMdx.frontmatter.updated}
      </p>
      <MDXRenderer>{data.file.childMdx.body}</MDXRenderer>
    </Article>
  </Layout>
);

export const privacyPageQuery = graphql`
  query {
    file(relativePath: { eq: "privacy-policy.mdx" }) {
      childMdx {
        frontmatter {
          updated(formatString: "MMM DD YYYY")
        }
        body
      }
    }
  }
`;

export default PrivacyPage;
